import { render, staticRenderFns } from "./DBAttributeTable.vue?vue&type=template&id=1aabeeb4&"
import script from "./DBAttributeTable.vue?vue&type=script&lang=js&"
export * from "./DBAttributeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports